import { createCrudPage } from './factories/crud-page.js';

export default createCrudPage({
  title: 'Menu Access',
  basePath: '/menu-access',
  columns: [
    { key: 'menu_name', label: 'Menu Page', sortable: true },
    { key: 'users_roles_names', label: 'User Roles', sortable: false },
  ],
  fields: [
    { key: 'menu_id', label: 'Menu Page', type: 'async-select',
      optionsUrl: '/menu/options', required: true },
    { key: 'users_roles', label: 'User Roles', type: 'checkbox-group',
      optionsUrl: '/users-roles/options' },
  ],
  defaultSort: { field: 'menu_name', dir: 'asc' },
});
